

export default {
  name: 'App',
}
